<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="body-modal">
    <form [formGroup]="addNewCustomTruckForm" [ngClass]="{ 'disabled-popup': !checkEntireAccess }">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required">
            <piqet-angular-common-input
              formControlName="truckName"
              [control]="addNewCustomTruckForm.get('truckName')"
              label="Truck name"
              placeholder="Truck name"
              [maxLength]="50"
              [submitted]="finalSubmitted"
            >
            </piqet-angular-common-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group required requiredWidths">
            <label class="sub-header-drpdown">Truck</label>
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #truck
              class="personalInputFiled TruckItems"
              [items]="truckList"
              [searchable]="false"
              formControlName="selectTruck"
              bindLabel="truckType"
              [searchFn]="truckTypeInputSearch"
              placeholder="Truck *"
              bindValue="id"
              [ngClass]="{ 'is-invalid': finalSubmitted }"
              (change)="selectedTruck($event)"
              groupBy="childItems"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="accordion-search form-control search-input"
                    id="inputValidation"
                    (input)="truck.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.truckType }}">
                  {{ item?.truckType }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (finalSubmitted || addNewCustomTruckForm.controls['selectTruck'].touched) &&
                addNewCustomTruckForm.controls['selectTruck'].errors
              "
            >
              <div
                *ngIf="addNewCustomTruckForm.controls['selectTruck'].errors?.['required'] && (finalSubmitted || addNewCustomTruckForm.controls['selectTruck'].touched)"
                class="input-error"
              >
                Truck is required
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              formControlName="tareMass"
              [control]="addNewCustomTruckForm.get('tareMass')"
              label="Tare mass (weight of empty vehicle in tonne)"
              placeholder="Tare mass (weight of empty vehicle in tonne)"
              [maxLength]="30"
              [submitted]="finalSubmitted"
              [minValue]="0"
              [maxValue]="100"
              [isPercentage]="false"
              [inputType]="'number'"
              [enableRangeValidation]="true"
            >
            </piqet-angular-common-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              formControlName="maximumLoading"
              [control]="addNewCustomTruckForm.get('maximumLoading')"
              label="Maximum loading "
              placeholder="Maximum loading "
              [submitted]="finalSubmitted"
              [minValue]="0"
              [maxValue]="100"
              [isPercentage]="false"
              [inputType]="'number'"
              [enableRangeValidation]="true"
            >
            </piqet-angular-common-input>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              formControlName="loadInTruck"
              [control]="addNewCustomTruckForm.get('loadInTruck')"
              label="Load in truck (tonne)"
              placeholder="Load in truck (tonne)"
              [maxLength]="30"
              [submitted]="finalSubmitted"
              [inputType]="'number'"
              [minValue]="0"
              [maxValue]="100"
              [enableRangeValidation]="true"
              (customBlur)="percentageCalc()"
            >
            </piqet-angular-common-input>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" aria-required="true">
            <piqet-angular-common-input
              formControlName="percentLoaded"
              [control]="addNewCustomTruckForm.get('percentLoaded')"
              label="Percentage loaded (%)"
              placeholder="Percentage loaded (%)"
              [submitted]="finalSubmitted"
              [inputType]="'number'"
              [minValue]="0"
              [maxValue]="100"
              [disabled]="true"
              [isPercentage]="true"
              [enableRangeValidation]="true"
            >
            </piqet-angular-common-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-5">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              formControlName="percentRural"
              [control]="addNewCustomTruckForm.get('percentRural')"
              label="Percentage rural"
              placeholder="Percentage rural"
              [submitted]="finalSubmitted"
              [inputType]="'number'"
              [minValue]="0"
              [maxValue]="100"
              [isPercentage]="true"
              [enableRangeValidation]="true"
              (customBlur)="setRuralPercentValue()"
            >
            </piqet-angular-common-input>
          </div>
        </div>
        <div class="col-sm-7">
          <div aria-required="true">
            <ngx-slider
              [options]="options"
              (userChange)="changeRuralValue($event)"
              formControlName="percentRuralSlider"
            ></ngx-slider>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-5">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              formControlName="percentEmptyReturns"
              [control]="addNewCustomTruckForm.get('percentEmptyReturns')"
              label="Percentage empty returns"
              placeholder="Percentage empty returns"
              [submitted]="finalSubmitted"
              [inputType]="'number'"
              [minValue]="0"
              [maxValue]="100"
              [isPercentage]="true"
              [enableRangeValidation]="true"
              (customBlur)="setEmptyReturnsPercentValue()"
            >
            </piqet-angular-common-input>
          </div>
        </div>
        <div class="col-sm-7">
          <div aria-required="true">
            <ngx-slider
              [options]="options"
              (userChange)="changeEmptyReturnsValue($event)"
              formControlName="percentEmptyReturnsSlider"
            ></ngx-slider>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="cutomBtn-margin required" aria-required="true">
            <piqet-angular-common-input
              formControlName="refrigerationDuration"
              [control]="addNewCustomTruckForm.get('refrigerationDuration')"
              label="Refrigeration duration (hours)"
              placeholder="Refrigeration duration (hours)"
              [maxLength]="30"
              [submitted]="finalSubmitted"
              [inputType]="'number'"
              [minValue]="0"
              [maxValue]="100"
              [enableRangeValidation]="true"
              (customBlur)="refrigerationBlur()"
            >
            </piqet-angular-common-input>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group requiredWidths" aria-required="true">
            <label class="sub-header-drpdown">Refrigeration type</label>
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              class="personalInputFiled"
              (change)="changeRefrigeration($event)"
              #selectRefrigerate
              [items]="refrigerationList"
              [searchable]="false"
              formControlName="refrigerationType"
              bindLabel="name"
              [searchFn]="refrigerationTypeInputSearch"
              placeholder="Not refrigerated"
              bindValue="id"
              [ngClass]="{ 'is-invalid': finalSubmitted }"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="accordion-search form-control search-input"
                    id="inputValidation"
                    (input)="selectRefrigerate.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (isRefrigerationDurationHrs || finalSubmitted) &&
                addNewCustomTruckForm.controls['refrigerationType'].errors
              "
            >
              <div
                *ngIf="addNewCustomTruckForm.controls['refrigerationType'].errors?.['required'] && isRefrigerationDurationHrs"
                class="input-error"
              >
                Refrigeration type is required
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12" *ngIf="isHideDropDown">
          <div class="form-group required">
            <label
              *ngIf="addNewCustomTruckForm.get('organizationName')?.value"
              class="sub-header-drpdown pb-2"
              >Organization</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #material
              [items]="organizationlist"
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationName"
              [searchFn]="commonInputSearch"
              [readonly]="isDisabledDropDown"
              placeholder="Organization"
              [(ngModel)]="setOrganizationValue"
              (change)="selectValue($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    (input)="material.filter($any($event.target).value)"
                    class="accordion-search form-control search-input"
                    id="inputValidation"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>

            <div
              *ngIf="
                (addNewCustomTruckForm.controls['organizationName']?.touched &&
                  addNewCustomTruckForm.controls['organizationName']?.invalid) ||
                addNewCustomTruckForm.controls['organizationName'].value?.name === 'Organization' ||
                (finalSubmitted && !addNewCustomTruckForm.controls['organizationName'].value?.name)
              "
              class="input-error"
            >
              Organization is required.
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      *ngIf="checkEntireAccess"
      (click)="onSave()"
    >
      Save
    </button>
  </div>
</div>
